/**
 * Maps input to a {@link ImportExportVersionConfig}.
 *
 * @param config A configuration-like object containing values to map into an {@link ImportExportVersionConfig}
 */
export function toImportExportVersionConfig(config) {
    return { formatversion: config === null || config === void 0 ? void 0 : config.formatversion };
}
//# sourceMappingURL=import-export-version-config.js.map